<template>
  <BaseInput :label="label" :errors="errors" :hasIcon="hasIcon">
    <component :is="loadIconPath" v-if="iconType" :iconColor="iconColor" />
    <input
      :id="name"
      :type="type"
      :class="{ hasErrors: errors, ...customClass }"
      :name="name"
      :placeholder="placeholder"
      autocomplete="off"
      :value="inputValue"
      :maxlength="maxLength"
      v-maska="mask"
      :disabled="disabled"
      @keyup="$emit(`update:${name}`, $event.target.value)"
      @blur="$emit(`update:${name}`, $event.target.value)"
    />
  </BaseInput>
</template>

<script setup>
import { defineAsyncComponent, computed } from "vue";
import BaseInput from "@/components/ui/inputs/BaseInput.vue";

const props = defineProps({
  name: { type: String, default: "formInputField" },
  label: { type: String, default: "Default label" },
  placeholder: { type: String, default: "Default placeholder" },
  inputValue: { type: String, default: "" },
  mask: { type: String, default: "" },
  type: { type: String, required: true },
  iconType: { type: String, required: false, default: "" },
  iconColor: { type: String, required: false },
  maxLength: { type: Number, default: null },
  disabled: { type: Boolean, default: false },
  errors: {
    type: String,
    default: null,
  },
  customClass: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

const hasIcon = !!props.iconType;

const loadIconPath = computed(() =>
  defineAsyncComponent(() =>
    import(
      /* @vite-ignore */ `../../../../src/components/icons/${props.iconType}.vue`
    )
  )
);

// defineEmits(["update:email"]);
</script>
